import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getMainNavigationLinks } from '../config/navigationLinks.js';
import { useT } from '../contexts/LocaleContext.jsx';
import '../styles/MainNavigation.css';  // Import styles

function MainNavigation( { profileImageURL }) {
  const navigate = useNavigate();
  const t = useT();
  const navigationLinks = getMainNavigationLinks();

  // Check sessionStorage if profileImageURL is not passed as a prop
  const currentProfileImageURL = profileImageURL || sessionStorage.getItem('ProfileImageURL');

  const renderNavigationButton = (link) => {
    if (link.requiresProfileImage) {
      return (
        <button 
          key={link.id}
          className="home-nav-button" 
          onClick={() => navigate(link.path)}
        >
          {currentProfileImageURL && (
            <img src={currentProfileImageURL} alt={t('navigation.profileImageAlt')} className="navigation-profile-image" />
          )}
          <span>{t(link.labelKey)}</span>
        </button>
      );
    }
    
    return (
      <button 
        key={link.id}
        className="home-nav-button" 
        onClick={() => navigate(link.path)}
      >
        <span>{t(link.labelKey)}</span>
      </button>
    );
  };
  
  return (
    <nav className="main-navigation" aria-label={t('navigation.main')}>
      <div className="home-nav-buttons">
        {navigationLinks.map(link => renderNavigationButton(link))}
      </div>
    </nav>
  );
}

export default MainNavigation;